import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { LinkWrapper } from '@components/AddRecordButton/AddRecordButton.style';
import UploadRecordsContent from '@components/Modal/Content/UploadRecordsModalContent/UploadRecordsContent';
import RoundedButton from '@components/RoundedButton/index';
import UploadedRecordsList from '@components/UploadedRecordsList/UploadedRecordsList';

import { useModal } from '@hooks/useModal';

import { TableContainer } from '@layouts/Layouts/TableLayout';

const messages = defineMessages({
  title: {
    id: 'uploadsMain.title',
    defaultMessage: 'Records/Documents',
  },
  button: {
    id: 'uploadsMain.button',
    defaultMessage: 'Upload Records',
  },
  noUploads: {
    id: 'uploadsMain.noUploads',
    defaultMessage: 'No Uploads',
  },
});

const Uploads: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();
  const { closeModal, openModal, setContent } = useModal();

  const handleOpenModal = () => {
    openModal({
      width: 500,
      props: {
        height: '300px',
      },
      children: null,
    });
    setContent({
      children: <UploadRecordsContent onSubmit={closeModal} />,
    });
  };

  return (
    <TableContainer>
      <UploadedRecordsList />

      <LinkWrapper>
        <RoundedButton onClick={handleOpenModal} width="180px">
          {formatMessage(messages.button)}
        </RoundedButton>
      </LinkWrapper>
    </TableContainer>
  );
};

export default Uploads;
